module.exports = __webpack_public_path__ + "static/media/easley_dyer.15820d93.jpg";